import React, { ReactNode } from 'react'

import { getRecordMerchant, useActiveMerchant } from 'lib/merchant-group'

import CompanySelector from './CompanySelector'
import CompanySessionProvider from './CompanySessionProvider'
import useFormCompany from './useFormCompany'

type FormCompanyScopeProps = {
  // Edição e duplicação já nascem na empresa do registro: o seletor só vale
  // para criação.
  enabled?: boolean
  // Edição: uuid do registro aberto. O formulário fica na empresa do registro
  // (registrada pela lista agregada) e o seletor não aparece. Precisa disso
  // porque o "Editar" de vários detalhes fecha o detalhe antes de abrir o
  // formulário, e com ele iria embora a empresa ativa.
  recordUuid?: string
  // Recebe o seletor "Empresa" (null fora da visão multi-empresas) para o
  // formulário mostrar no topo.
  children: (companySelector: ReactNode) => ReactNode
}

/**
 * SC-10999: o mesmo arranjo do formulário de cobrança/recorrência, para os
 * formulários de criação que vivem num modal próprio (plano, link de
 * contratação, link de cadastro). Na visão multi-empresas a empresa escolhida
 * vira a empresa ativa e a sessão do formulário; trocar a empresa remonta o
 * formulário, que volta a buscar tudo com o token da nova. Fora do grupo só
 * repassa o formulário.
 *
 * Deve ser montado só com o formulário aberto: enquanto montado, a empresa
 * escolhida vale para as chamadas da página inteira.
 */
const FormCompanyScope = ({
  enabled = true,
  recordUuid,
  children
}: FormCompanyScopeProps) => {
  const { companyUuid, setCompanyUuid } = useFormCompany({
    enabled: enabled && !recordUuid
  })
  // Fora da visão do grupo nada é registrado por registro: não faz nada
  const recordMerchant = getRecordMerchant(recordUuid)
  useActiveMerchant(recordMerchant)

  return (
    <CompanySessionProvider companyUuid={recordMerchant || companyUuid}>
      <React.Fragment key={companyUuid || 'context'}>
        {children(
          <CompanySelector value={companyUuid} onChange={setCompanyUuid} />
        )}
      </React.Fragment>
    </CompanySessionProvider>
  )
}

export default FormCompanyScope
